import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/pro-regular-svg-icons";
import { WithTranslation } from "react-i18next";
import ServiceFeeService from "../../services/ServiceFeesService";
import UserService, { RoleGroupNames } from "../../services/UserService";

interface PromotionTemplateCellComponentProps extends WithTranslation {
    data: any;
}

interface PromotionTemplateCellComponentState {
    eventUKSMIndicator: boolean;
}

class PromotionTemplateCellComponent extends React.Component<PromotionTemplateCellComponentProps> {
    state: PromotionTemplateCellComponentState;

    constructor(props: PromotionTemplateCellComponentProps) {
        super(props);
        this.state = {
            eventUKSMIndicator: UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ? true : false,
        };
    }

    //This is needed here to check for some conditions when the component mounts.
    componentDidMount() {}

    render() {
        return (
            <div hidden={!this.state.eventUKSMIndicator}>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <Link
                            title="Edit"
                            className="icon-btn"
                            to={{
                                pathname: "/matrixView",
                                state: {
                                    id: this.props.data.data.id,
                                    isEdit: true,
                                },
                            }}
                        >
                            <FontAwesomeIcon icon={faPen} />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default PromotionTemplateCellComponent;
